import React from "react";
import { HeaderLogo, HeaderBody, HeaderIcon, HeaderFilter, HeaderIncoming } from "./";
import { Container, Nav, Row } from "react-bootstrap";
import myLogo from "../Assets/Logo/NYC-Logo.png";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Link, useLocation } from "react-router-dom";
import "../css/custom.css"
import "../css/style.css" 
const TopNavHeader = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pathnames = location.pathname.split('/').filter((x) => x);
 // Check if the pathnames array includes both 'home' and 'inventory'
 const shouldInventoryDisplayFilter = pathnames.includes('home') && pathnames.includes('inventory');
 const shouldAmazonDisplayFilter = pathnames.includes('home') && pathnames.includes('amazon-inventory');
 const shouldIncomingDisplayFilter = pathnames.includes('home') && pathnames.includes('incoming');

 return (
   <div className="border box-border shadow-md">
     <HeaderLogo />
      <HeaderFilter />
   </div>
 );
};

export default TopNavHeader;
